// @ts-nocheck
import {
  createUseReadContract,
  createUseWriteContract,
  createUseSimulateContract,
  createUseWatchContractEvent,
} from 'wagmi/codegen'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DelegatedAccount
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const delegatedAccountAbi = [
  { type: 'constructor', inputs: [], stateMutability: 'nonpayable' },
  { type: 'fallback', stateMutability: 'nonpayable' },
  {
    type: 'function',
    inputs: [],
    name: 'ASSIGN_OPERATOR_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'acceptOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'accountId',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_operator', internalType: 'address', type: 'address' },
      { name: '_deadline', internalType: 'uint256', type: 'uint256' },
      { name: '_sig', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'addOperator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'collateralToken',
    outputs: [{ name: '', internalType: 'contract IERC20', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'amount', internalType: 'uint256', type: 'uint256' }],
    name: 'createAccount',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'eip712Domain',
    outputs: [
      { name: 'fields', internalType: 'bytes1', type: 'bytes1' },
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'version', internalType: 'string', type: 'string' },
      { name: 'chainId', internalType: 'uint256', type: 'uint256' },
      { name: 'verifyingContract', internalType: 'address', type: 'address' },
      { name: 'salt', internalType: 'bytes32', type: 'bytes32' },
      { name: 'extensions', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'exchange',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_owner', internalType: 'address', type: 'address' },
      { name: '_operator', internalType: 'address', type: 'address' },
      { name: '_exchange', internalType: 'address', type: 'address' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'invalidateOperatorNonce',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_operator', internalType: 'address', type: 'address' }],
    name: 'isOperator',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    name: 'operatorAllowlist',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'operatorNonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'operators',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingOwner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_operator', internalType: 'address', type: 'address' }],
    name: 'removeOperator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'resignOperator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amount', internalType: 'uint256', type: 'uint256' }],
    name: 'setExchangeApproval',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'selector', internalType: 'bytes4', type: 'bytes4' },
      { name: 'allowed', internalType: 'bool', type: 'bool' },
    ],
    name: 'setOperatorAllowlist',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amount', internalType: 'uint256', type: 'uint256' }],
    name: 'withdrawCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'AccountCreated',
  },
  { type: 'event', anonymous: false, inputs: [], name: 'EIP712DomainChanged' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ExchangeApprovalUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'version',
        internalType: 'uint64',
        type: 'uint64',
        indexed: false,
      },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OperatorAdded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'selector',
        internalType: 'bytes4',
        type: 'bytes4',
        indexed: true,
      },
      { name: 'allowed', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'OperatorAllowlistUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newNonce',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OperatorNonceInvalidated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OperatorRemoved',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferStarted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  { type: 'error', inputs: [], name: 'AccountAlreadyCreated' },
  { type: 'error', inputs: [], name: 'AccountNotCreated' },
  { type: 'error', inputs: [], name: 'ECDSAInvalidSignature' },
  {
    type: 'error',
    inputs: [{ name: 'length', internalType: 'uint256', type: 'uint256' }],
    name: 'ECDSAInvalidSignatureLength',
  },
  {
    type: 'error',
    inputs: [{ name: 's', internalType: 'bytes32', type: 'bytes32' }],
    name: 'ECDSAInvalidSignatureS',
  },
  { type: 'error', inputs: [], name: 'InsufficientBalance' },
  { type: 'error', inputs: [], name: 'InvalidInitialization' },
  { type: 'error', inputs: [], name: 'InvalidReturnData' },
  { type: 'error', inputs: [], name: 'InvalidSignature' },
  { type: 'error', inputs: [], name: 'NotInitializing' },
  { type: 'error', inputs: [], name: 'OnlyOwnerOrOperator' },
  {
    type: 'error',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'OwnableInvalidOwner',
  },
  {
    type: 'error',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'OwnableUnauthorizedAccount',
  },
  {
    type: 'error',
    inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
    name: 'SafeERC20FailedOperation',
  },
  {
    type: 'error',
    inputs: [{ name: 'selector', internalType: 'bytes4', type: 'bytes4' }],
    name: 'SelectorNotAllowed',
  },
  { type: 'error', inputs: [], name: 'SignatureExpired' },
  { type: 'error', inputs: [], name: 'ZeroAddress' },
  { type: 'error', inputs: [], name: 'ZeroAmount' },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// React
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__
 */
export const useReadDelegatedAccount = /*#__PURE__*/ createUseReadContract({
  abi: delegatedAccountAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"ASSIGN_OPERATOR_TYPEHASH"`
 */
export const useReadDelegatedAccountAssignOperatorTypehash =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'ASSIGN_OPERATOR_TYPEHASH',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 */
export const useReadDelegatedAccountDomainSeparator =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"accountId"`
 */
export const useReadDelegatedAccountAccountId =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'accountId',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"collateralToken"`
 */
export const useReadDelegatedAccountCollateralToken =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'collateralToken',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"eip712Domain"`
 */
export const useReadDelegatedAccountEip712Domain =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'eip712Domain',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"exchange"`
 */
export const useReadDelegatedAccountExchange =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'exchange',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"isOperator"`
 */
export const useReadDelegatedAccountIsOperator =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'isOperator',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"operatorAllowlist"`
 */
export const useReadDelegatedAccountOperatorAllowlist =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'operatorAllowlist',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"operatorNonces"`
 */
export const useReadDelegatedAccountOperatorNonces =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'operatorNonces',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"operators"`
 */
export const useReadDelegatedAccountOperators =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'operators',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"owner"`
 */
export const useReadDelegatedAccountOwner = /*#__PURE__*/ createUseReadContract(
  { abi: delegatedAccountAbi, functionName: 'owner' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"pendingOwner"`
 */
export const useReadDelegatedAccountPendingOwner =
  /*#__PURE__*/ createUseReadContract({
    abi: delegatedAccountAbi,
    functionName: 'pendingOwner',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__
 */
export const useWriteDelegatedAccount = /*#__PURE__*/ createUseWriteContract({
  abi: delegatedAccountAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"acceptOwnership"`
 */
export const useWriteDelegatedAccountAcceptOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'acceptOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"addOperator"`
 */
export const useWriteDelegatedAccountAddOperator =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'addOperator',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"createAccount"`
 */
export const useWriteDelegatedAccountCreateAccount =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'createAccount',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"initialize"`
 */
export const useWriteDelegatedAccountInitialize =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"invalidateOperatorNonce"`
 */
export const useWriteDelegatedAccountInvalidateOperatorNonce =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'invalidateOperatorNonce',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"removeOperator"`
 */
export const useWriteDelegatedAccountRemoveOperator =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'removeOperator',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteDelegatedAccountRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"rescueTokens"`
 */
export const useWriteDelegatedAccountRescueTokens =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"resignOperator"`
 */
export const useWriteDelegatedAccountResignOperator =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'resignOperator',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"setExchangeApproval"`
 */
export const useWriteDelegatedAccountSetExchangeApproval =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'setExchangeApproval',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"setOperatorAllowlist"`
 */
export const useWriteDelegatedAccountSetOperatorAllowlist =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'setOperatorAllowlist',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteDelegatedAccountTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"withdrawCollateral"`
 */
export const useWriteDelegatedAccountWithdrawCollateral =
  /*#__PURE__*/ createUseWriteContract({
    abi: delegatedAccountAbi,
    functionName: 'withdrawCollateral',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__
 */
export const useSimulateDelegatedAccount =
  /*#__PURE__*/ createUseSimulateContract({ abi: delegatedAccountAbi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"acceptOwnership"`
 */
export const useSimulateDelegatedAccountAcceptOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'acceptOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"addOperator"`
 */
export const useSimulateDelegatedAccountAddOperator =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'addOperator',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"createAccount"`
 */
export const useSimulateDelegatedAccountCreateAccount =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'createAccount',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"initialize"`
 */
export const useSimulateDelegatedAccountInitialize =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"invalidateOperatorNonce"`
 */
export const useSimulateDelegatedAccountInvalidateOperatorNonce =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'invalidateOperatorNonce',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"removeOperator"`
 */
export const useSimulateDelegatedAccountRemoveOperator =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'removeOperator',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateDelegatedAccountRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"rescueTokens"`
 */
export const useSimulateDelegatedAccountRescueTokens =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"resignOperator"`
 */
export const useSimulateDelegatedAccountResignOperator =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'resignOperator',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"setExchangeApproval"`
 */
export const useSimulateDelegatedAccountSetExchangeApproval =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'setExchangeApproval',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"setOperatorAllowlist"`
 */
export const useSimulateDelegatedAccountSetOperatorAllowlist =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'setOperatorAllowlist',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateDelegatedAccountTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link delegatedAccountAbi}__ and `functionName` set to `"withdrawCollateral"`
 */
export const useSimulateDelegatedAccountWithdrawCollateral =
  /*#__PURE__*/ createUseSimulateContract({
    abi: delegatedAccountAbi,
    functionName: 'withdrawCollateral',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__
 */
export const useWatchDelegatedAccountEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: delegatedAccountAbi })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"AccountCreated"`
 */
export const useWatchDelegatedAccountAccountCreatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'AccountCreated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"EIP712DomainChanged"`
 */
export const useWatchDelegatedAccountEip712DomainChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'EIP712DomainChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"ExchangeApprovalUpdated"`
 */
export const useWatchDelegatedAccountExchangeApprovalUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'ExchangeApprovalUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"Initialized"`
 */
export const useWatchDelegatedAccountInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"OperatorAdded"`
 */
export const useWatchDelegatedAccountOperatorAddedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'OperatorAdded',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"OperatorAllowlistUpdated"`
 */
export const useWatchDelegatedAccountOperatorAllowlistUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'OperatorAllowlistUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"OperatorNonceInvalidated"`
 */
export const useWatchDelegatedAccountOperatorNonceInvalidatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'OperatorNonceInvalidated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"OperatorRemoved"`
 */
export const useWatchDelegatedAccountOperatorRemovedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'OperatorRemoved',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"OwnershipTransferStarted"`
 */
export const useWatchDelegatedAccountOwnershipTransferStartedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'OwnershipTransferStarted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link delegatedAccountAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchDelegatedAccountOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: delegatedAccountAbi,
    eventName: 'OwnershipTransferred',
  })
